/**
 * Shared QSR demo dataset — one source of truth so every module (leaderboard,
 * speed, labour, sales, delivery, drawer) shows consistent numbers.
 * Sample data only; used when a demo tenant has no live location metrics.
 */

export const DAYPARTS = ['Open', 'Bfast', 'Lunch', 'Arvo', 'Dinner', 'Late', 'Close'];

export const QSR_STORES = [
  {
    id: 'footscray', name: 'Footscray', manager: 'Dan M.',
    splh: 78.4, sos: 3.1, accuracy: 96.8, weeklySales: 84200, labourPct: 26.1,
    avgCheck: 18.4, comboAttach: 62, wastePct: 2.1, voidPct: 0.9,
    sosByDaypart: [2.4, 2.8, 3.6, 2.9, 4.1, 3.0, 2.2],
    labourByDaypart: [22, 24, 29, 27, 31, 26, 21],
    salesByDaypart: [6, 9, 26, 14, 28, 12, 5],
    sosTrend: [3.6, 3.5, 3.4, 3.5, 3.3, 3.4, 3.2, 3.3, 3.2, 3.1, 3.2, 3.1],
    splhTrend: [70, 71, 72, 71, 73, 74, 75, 76, 76, 77, 78, 78.4],
    salesTrend: [74, 76, 75, 78, 79, 80, 81, 83, 82, 84, 83, 84.2],
    delivery: { mix: 28, uberRating: 4.7, doordashRating: 4.6, avgDeliveryMin: 24, marginPct: 14 },
    topItems: [{ name: 'Classic Grill Burger', pct: 22 }, { name: 'Loaded Fries', pct: 16 }, { name: 'Grilled Chicken Wrap', pct: 13 }],
  },
  {
    id: 'penrith', name: 'Penrith', manager: 'Aisha K.',
    splh: 71.2, sos: 3.9, accuracy: 94.2, weeklySales: 72600, labourPct: 28.4,
    avgCheck: 17.1, comboAttach: 55, wastePct: 3.0, voidPct: 1.4,
    sosByDaypart: [3.0, 3.4, 4.4, 3.6, 5.0, 3.8, 2.9],
    labourByDaypart: [25, 27, 32, 29, 34, 28, 24],
    salesByDaypart: [5, 8, 24, 15, 30, 13, 5],
    sosTrend: [4.4, 4.3, 4.2, 4.1, 4.2, 4.0, 4.1, 3.9, 4.0, 3.9, 3.9, 3.9],
    splhTrend: [66, 67, 68, 67, 69, 70, 70, 71, 71, 71, 72, 71.2],
    salesTrend: [70, 71, 70, 72, 73, 72, 74, 73, 74, 73, 72, 72.6],
    delivery: { mix: 34, uberRating: 4.4, doordashRating: 4.3, avgDeliveryMin: 29, marginPct: 11 },
    topItems: [{ name: 'Classic Grill Burger', pct: 20 }, { name: 'Double Stack', pct: 15 }, { name: 'Loaded Fries', pct: 14 }],
  },
  {
    id: 'southport', name: 'Southport', manager: 'Rhys T.',
    splh: 63.9, sos: 4.6, accuracy: 91.5, weeklySales: 61300, labourPct: 31.7,
    avgCheck: 16.3, comboAttach: 48, wastePct: 4.2, voidPct: 2.1,
    sosByDaypart: [3.6, 4.0, 5.2, 4.4, 6.1, 4.6, 3.4],
    labourByDaypart: [28, 30, 36, 33, 39, 32, 27],
    salesByDaypart: [5, 7, 22, 16, 32, 13, 5],
    sosTrend: [5.1, 5.0, 4.9, 5.0, 4.8, 4.9, 4.7, 4.8, 4.7, 4.6, 4.7, 4.6],
    splhTrend: [61, 62, 61, 63, 62, 63, 64, 63, 64, 64, 64, 63.9],
    salesTrend: [60, 61, 60, 62, 61, 62, 61, 62, 61, 62, 61, 61.3],
    delivery: { mix: 41, uberRating: 4.1, doordashRating: 4.0, avgDeliveryMin: 33, marginPct: 8 },
    topItems: [{ name: 'Classic Grill Burger', pct: 19 }, { name: 'Loaded Fries', pct: 15 }, { name: 'Kids Grill Box', pct: 12 }],
  },
  {
    id: 'joondalup', name: 'Joondalup', manager: 'Priya S.',
    splh: 74.6, sos: 3.4, accuracy: 95.4, weeklySales: 69800, labourPct: 27.2,
    avgCheck: 18.0, comboAttach: 58, wastePct: 2.6, voidPct: 1.1,
    sosByDaypart: [2.6, 3.0, 3.9, 3.1, 4.4, 3.2, 2.4],
    labourByDaypart: [24, 26, 32, 29, 35, 28, 23],
    salesByDaypart: [6, 8, 24, 15, 30, 12, 5],
    sosTrend: [3.9, 3.8, 3.7, 3.8, 3.6, 3.7, 3.5, 3.6, 3.5, 3.4, 3.5, 3.4],
    splhTrend: [69, 70, 71, 70, 72, 72, 73, 73, 74, 74, 74, 74.6],
    salesTrend: [67, 68, 67, 69, 68, 69, 68, 69, 69, 70, 69, 69.8],
    delivery: { mix: 30, uberRating: 4.5, doordashRating: 4.4, avgDeliveryMin: 26, marginPct: 13 },
    topItems: [{ name: 'Classic Grill Burger', pct: 21 }, { name: 'Double Stack', pct: 14 }, { name: 'Loaded Fries', pct: 13 }],
  },
  {
    id: 'prospect', name: 'Prospect', manager: 'Tom H.',
    splh: 68.3, sos: 4.1, accuracy: 93.1, weeklySales: 66100, labourPct: 29.3,
    avgCheck: 16.9, comboAttach: 52, wastePct: 3.4, voidPct: 1.7,
    sosByDaypart: [3.2, 3.6, 4.7, 3.9, 5.3, 4.0, 3.1],
    labourByDaypart: [26, 28, 34, 31, 37, 30, 25],
    salesByDaypart: [5, 7, 23, 15, 31, 13, 6],
    sosTrend: [4.6, 4.5, 4.4, 4.5, 4.3, 4.4, 4.2, 4.3, 4.2, 4.1, 4.2, 4.1],
    splhTrend: [64, 65, 66, 65, 67, 67, 68, 67, 68, 68, 68, 68.3],
    salesTrend: [64, 65, 64, 66, 65, 66, 65, 66, 65, 66, 65, 66.1],
    delivery: { mix: 36, uberRating: 4.2, doordashRating: 4.1, avgDeliveryMin: 30, marginPct: 10 },
    topItems: [{ name: 'Classic Grill Burger', pct: 20 }, { name: 'Loaded Fries', pct: 15 }, { name: 'Grilled Chicken Wrap', pct: 12 }],
  },
];

export const TARGETS = { splh: 75, sos: 3.5, accuracy: 95, labourPct: 27 };

export const avgBy = (key, stores = QSR_STORES) =>
  stores.reduce((s, x) => s + (x[key] || 0), 0) / stores.length;

export const money = (n) => '$' + Math.round(n).toLocaleString();

// Waste & voids detail per store (add-on module)
export const WASTE_DETAIL = {
  footscray: { wasteTrend: [2.6, 2.5, 2.4, 2.3, 2.2, 2.1], voidTrend: [1.2, 1.1, 1.0, 0.9, 0.9, 0.9], lostPerWk: 1760, reasons: [{ name: 'Prep over-portioning', pct: 34 }, { name: 'Expired stock', pct: 26 }, { name: 'Dropped / remake', pct: 22 }, { name: 'Refunds / comps', pct: 18 }] },
  penrith: { wasteTrend: [3.4, 3.3, 3.2, 3.1, 3.0, 3.0], voidTrend: [1.7, 1.6, 1.5, 1.5, 1.4, 1.4], lostPerWk: 2180, reasons: [{ name: 'Expired stock', pct: 31 }, { name: 'Prep over-portioning', pct: 29 }, { name: 'Dropped / remake', pct: 24 }, { name: 'Refunds / comps', pct: 16 }] },
  southport: { wasteTrend: [4.6, 4.5, 4.4, 4.3, 4.2, 4.2], voidTrend: [2.4, 2.3, 2.2, 2.2, 2.1, 2.1], lostPerWk: 2580, reasons: [{ name: 'Dropped / remake', pct: 33 }, { name: 'Expired stock', pct: 28 }, { name: 'Prep over-portioning', pct: 23 }, { name: 'Refunds / comps', pct: 16 }] },
  joondalup: { wasteTrend: [3.0, 2.9, 2.8, 2.7, 2.6, 2.6], voidTrend: [1.4, 1.3, 1.2, 1.2, 1.1, 1.1], lostPerWk: 1980, reasons: [{ name: 'Prep over-portioning', pct: 32 }, { name: 'Expired stock', pct: 27 }, { name: 'Dropped / remake', pct: 24 }, { name: 'Refunds / comps', pct: 17 }] },
  prospect: { wasteTrend: [3.8, 3.7, 3.6, 3.5, 3.4, 3.4], voidTrend: [2.0, 1.9, 1.8, 1.8, 1.7, 1.7], lostPerWk: 2260, reasons: [{ name: 'Expired stock', pct: 30 }, { name: 'Dropped / remake', pct: 28 }, { name: 'Prep over-portioning', pct: 25 }, { name: 'Refunds / comps', pct: 17 }] },
};

// Next-day day-part sales forecast for a typical store ($k) + recommended crew
export const NETWORK_FORECAST = [
  { daypart: 'Open', predicted: 0.7, typical: 0.6, recStaff: 3 },
  { daypart: 'Bfast', predicted: 1.1, typical: 1.0, recStaff: 4 },
  { daypart: 'Lunch', predicted: 3.2, typical: 3.0, recStaff: 7 },
  { daypart: 'Arvo', predicted: 1.8, typical: 1.7, recStaff: 5 },
  { daypart: 'Dinner', predicted: 3.9, typical: 3.4, recStaff: 8 },
  { daypart: 'Late', predicted: 1.5, typical: 1.4, recStaff: 5 },
  { daypart: 'Close', predicted: 0.6, typical: 0.6, recStaff: 3 },
];

export const STAFF_COUNT = 42;
